export const visibilityTable = [
  { Scale: '0', Description: 'Dense fog', Limit: '50 yards' },
  { Scale: '1', Description: 'Thick fog', Limit: '300 yards' },
  { Scale: '2', Description: 'Fog', Limit: '600 yards' },
  { Scale: '3', Description: 'Moderate fog', Limit: '½ mile' },
  { Scale: '4', Description: 'Mist or thin fog', Limit: '1 mile' },
  { Scale: '5', Description: 'Poor visibility', Limit: '2 miles' },
  { Scale: '6', Description: 'Moderate visibility', Limit: '5 miles' },
  { Scale: '7', Description: 'Good visibility', Limit: '10 miles' },
  { Scale: '8', Description: 'Very good visibility', Limit: '30 miles' },
  { Scale: '9', Description: 'Exceptional visibility', Limit: 'over 30 miles' },
];

export const beaufortWindScale = [
  { Force: '0', WindSpeed: 'Less Than 1', WmoClassification: 'Calm', WaterAppearance: 'Sea Surface Smooth and Mirror-like', LandEffects: 'Calm, Smoke Rises Vertically' },
  { Force: '1', WindSpeed: '1-3', WmoClassification: 'Light Air', WaterAppearance: 'Scaly Ripples, No Foam Crests', LandEffects: 'Smoke Drift Indicates Wind Direction, Still Wind Vanes' },
  { Force: '2', WindSpeed: '4-6', WmoClassification: 'Light Breeze', WaterAppearance: 'Small Wavelets, Crests Glassy, No Breaking', LandEffects: 'Wind Felt on Face, Leaves Rustle, Vanes Begin to Move' },
  { Force: '3', WindSpeed: '7-10', WmoClassification: 'Gentle Breeze', WaterAppearance: 'Large Wavelets, Crests Begin to Break, Scattered Whitecaps', LandEffects: 'Leaves and Small Twigs Constantly Moving, Light Flags Extended' },
  { Force: '4', WindSpeed: '11-16', WmoClassification: 'Moderate Breeze', WaterAppearance: 'Small Waves 1-4 Ft. Becoming Longer, Numerous Whitecaps', LandEffects: 'Dust, Leaves, and Loose Paper Lifted, Small Tree Branches Move' },
  { Force: '5', WindSpeed: '17-21', WmoClassification: 'Fresh Breeze', WaterAppearance: 'Moderate Waves 4-8 Ft Taking Longer Form, Many Whitecaps, Some Spray', LandEffects: 'Small Trees in Leaf Begin to Sway' },
  { Force: '6', WindSpeed: '22-27', WmoClassification: 'Strong Breeze', WaterAppearance: 'Larger Waves 8-13 Ft, Whitecaps Common, More Spray', LandEffects: 'Larger Tree Branches Moving, Whistling in Wires' },
  { Force: '7', WindSpeed: '28-33', WmoClassification: 'Near Gale', WaterAppearance: 'Sea Heaps Up, Waves 13-20 Ft, White Foam Streaks off Breakers', LandEffects: 'Whole Trees Moving, Resistance Felt Walking Against Wind' },
  { Force: '8', WindSpeed: '34-40', WmoClassification: 'Gale', WaterAppearance: 'Moderately High (13-20 Ft) Waves of Greater Length, Edges of Crests Begin to Break into Spindrift, Foam Blown in Streaks', LandEffects: 'Whole Trees in Motion, Resistance Felt Walking Against Wind' },
  { Force: '9', WindSpeed: '41-47', WmoClassification: 'Strong Gale', WaterAppearance: 'High Waves (20 Ft), Sea Begins to Roll, Dense Streaks of Foam, Spray May Reduce Visibility', LandEffects: 'Slight Structural Damage Occurs, Slate Blows off Roofs' },
  { Force: '10', WindSpeed: '48-55', WmoClassification: 'Storm', WaterAppearance: 'Very High Waves (20-30 Ft) with Overhanging Crests, Sea White with Densely Blown Foam, Heavy Rolling, Lowered Visibility', LandEffects: 'Seldom Experienced on Land, Trees Broken or Uprooted, "Considerable Structural Damage"' },
  { Force: '11', WindSpeed: '56-63', WmoClassification: 'Violent Storm', WaterAppearance: 'Exceptionally High (30-45 Ft) Waves, Foam Patches Cover Sea, Visibility More Reduced', LandEffects: '' },
  { Force: '12', WindSpeed: '64+', WmoClassification: 'Hurricane', WaterAppearance: 'Air Filled with Foam, Waves Over 45 Ft, Sea Completely White with Driving Spray, Visibility Greatly Reduced', LandEffects: '' },
];

export const figureSpellingData = [
  { Figure: '0', Spelling: 'Nadazero', Pronounced: 'NAH-DAH-ZAY-ROH' },
  { Figure: '1', Spelling: 'Unaone', Pronounced: 'OO-NAH-WUN' },
  { Figure: '2', Spelling: 'Bissotwo', Pronounced: 'BEES-SOH-TOO' },
  { Figure: '3', Spelling: 'Terrathree', Pronounced: 'TAY-RAH-TREE' },
  { Figure: '4', Spelling: 'Kartefour', Pronounced: 'KAR-TAY-FOWER' },
  { Figure: '5', Spelling: 'Pantafive', Pronounced: 'PAN-TAH-FIVE' },
  { Figure: '6', Spelling: 'Sosisix', Pronounced: 'SOK-SEE-SIX' },
  { Figure: '7', Spelling: 'Setteseven', Pronounced: 'SAY-TAH-SEVEN' },
  { Figure: '8', Spelling: 'Oktoeight', Pronounced: 'OK-TOH-AIR' },
  { Figure: '9', Spelling: 'Novenine', Pronounced: 'NO-VAY-NINER' },
  { Figure: 'Decimal point', Spelling: 'Decimal', Pronounced: 'DAY-SEE-MAL' },
  { Figure: 'Full stop', Spelling: 'Stop', Pronounced: 'STOP' },
];

export const letterSpellingData = [
  { Letter: 'A', CodeWorld: 'Alfa', Pronounced: 'AL FAH' },
  { Letter: 'B', CodeWorld: 'Bravo', Pronounced: 'BRAH VOH' },
  { Letter: 'C', CodeWorld: 'Charlie', Pronounced: 'CHAR LEE (or SHAR LEE)' },
  { Letter: 'D', CodeWorld: 'Delta', Pronounced: 'DELL TAH' },
  { Letter: 'E', CodeWorld: 'Echo', Pronounced: 'ECK OH' },
  { Letter: 'F', CodeWorld: 'Foxtrot', Pronounced: 'FOKS TROT' },
  { Letter: 'G', CodeWorld: 'Golf', Pronounced: 'GOLF' },
  { Letter: 'H', CodeWorld: 'Hotel', Pronounced: 'HOH TELL' },
  { Letter: 'I', CodeWorld: 'India', Pronounced: 'IN DEE AH' },
  { Letter: 'J', CodeWorld: 'Juliett', Pronounced: 'JEW LEE ETT' },
  { Letter: 'K', CodeWorld: 'Kilo', Pronounced: 'KEY LOH' },
  { Letter: 'L', CodeWorld: 'Lima', Pronounced: 'LEE MAH' },
  { Letter: 'M', CodeWorld: 'Mike', Pronounced: 'MIKE' },
  { Letter: 'N', CodeWorld: 'Nowember', Pronounced: 'NO VEM BER' },
  { Letter: 'O', CodeWorld: 'Oscar', Pronounced: 'OSS CAH' },
  { Letter: 'P', CodeWorld: 'Papa', Pronounced: 'PAH PAH' },
  { Letter: 'Q', CodeWorld: 'Quebec', Pronounced: 'KEH BECK' },
  { Letter: 'R', CodeWorld: 'Romeo', Pronounced: 'ROW ME OH' },
  { Letter: 'S', CodeWorld: 'Sierra', Pronounced: 'SEE AIR RAH' },
  { Letter: 'T', CodeWorld: 'Tango', Pronounced: 'TANG GO' },
  { Letter: 'U', CodeWorld: 'Uniform', Pronounced: 'YOU NEE FORM' },
  { Letter: 'V', CodeWorld: 'Victor', Pronounced: 'VIK TAH' },
  { Letter: 'W', CodeWorld: 'Whiskey', Pronounced: 'WISS KEY' },
  { Letter: 'X', CodeWorld: 'X-ray', Pronounced: 'ECKS RAY' },
  { Letter: 'Y', CodeWorld: 'Yankee', Pronounced: 'YANG KEY' },
  { Letter: 'Z', CodeWorld: 'Zulu', Pronounced: 'ZOO LOO' },
];

export const maritimeAcronymsData = [
  { Acronym: 'ABS', FullForm: 'American Bureau of Shipping' },
  { Acronym: 'ACOPS', FullForm: 'Advisory Committee on Protection of the Sea' },
  { Acronym: 'AFRA', FullForm: 'Average freight rate assessments' },
  { Acronym: 'AIMU', FullForm: 'American Institute of Marine Underwriters' },
  { Acronym: 'AMVER', FullForm: 'Automated Mutual-Assistance Vessel Rescue System' },
  { Acronym: 'ARPA', FullForm: 'Automatic radar plotting aids' },
  { Acronym: 'ASEAN', FullForm: "Association' of South East Asian Nations" },
  { Acronym: 'ATL', FullForm: 'Actual total loss' },
  { Acronym: 'BIFFEX', FullForm: 'The Baltic International Freight Futures Exchange' },
  { Acronym: 'BIMCO', FullForm: 'The Baltic & International Maritime Council' },
  { Acronym: 'BTU', FullForm: 'Bow thruster unit' },
  { Acronym: 'BV', FullForm: 'Bureau Veritas' },
  { Acronym: 'CARICOM', FullForm: 'Caribbean Community' },
  { Acronym: 'CTL', FullForm: 'Constructive total loss' },
  { Acronym: 'DISH', FullForm: 'Data interchange in shipping' },
  { Acronym: 'DNV', FullForm: 'Del Norske Veritas' },
  { Acronym: 'EDIFACT', FullForm: 'Electronic data interchange for administration, commerce and transport' },
  { Acronym: 'EFTA', FullForm: 'European Free Trade Association' },
  { Acronym: 'EPIRB', FullForm: 'Emergency position-indicating radio beacon' },
  { Acronym: 'FACS', FullForm: 'Federation of American Controlled Shipping' },
  { Acronym: 'FDWT', FullForm: 'Formula deadweight tonnage' },
  { Acronym: 'FOC', FullForm: 'Flag of convenience' },
  { Acronym: 'FONASBA', FullForm: 'Federation of National Associations of Shipbrokers and Agents' },
  { Acronym: 'FSI', FullForm: 'Flag state implementation' },
  { Acronym: 'GATT', FullForm: 'General agreement on tariff and trade' },
  { Acronym: 'GL', FullForm: 'Germanischer Lloyd' },
  { Acronym: 'GMDSS', FullForm: 'Global Maritime Distress & Safety System' },
  { Acronym: 'GPS', FullForm: 'Global Positioning system' },
  { Acronym: 'IACS', FullForm: 'International Association of Classification Societies' },
  { Acronym: 'IALA', FullForm: 'International Association of Lighthouse Authorities' },
  { Acronym: 'IAPH', FullForm: 'International Association of Ports and Harbours' },
  { Acronym: 'ICC', FullForm: 'International Chamber of Commerce' },
  { Acronym: 'ICES', FullForm: 'International Council for the Exploration of the Sea' },
  { Acronym: 'ICHCA', FullForm: 'International Cargo Handling Coordination Association' },
  { Acronym: 'IMIF', FullForm: 'International Maritime Industry Forum' },
  { Acronym: 'IMO', FullForm: 'International Maritime Organization' },
  { Acronym: 'IMPA', FullForm: 'International Marine Purchasing Association' },
  { Acronym: 'INMARSAT', FullForm: 'International Mobile Satellite Organization' },
  { Acronym: 'INSA', FullForm: 'International Shipowners\' Association' },
  { Acronym: 'INTERCARGO', FullForm: 'International Association of Dry Cargo Shipowners' },
  { Acronym: 'INTERTANKO', FullForm: 'International Association of Independent Tanker Owners' },
  { Acronym: 'IRS', FullForm: 'Indian Register of Shipping' },
  { Acronym: 'ISF', FullForm: 'International Shipping Federation' },
  { Acronym: 'ISM', FullForm: 'International Safety Management' },
  { Acronym: 'ISO', FullForm: 'International Organization for Standardization' },
  { Acronym: 'ISSA', FullForm: 'International Ship Suppliers Association' },
  { Acronym: 'ITF', FullForm: 'International Transport Workers Federation' },
  { Acronym: 'ITOPF', FullForm: 'International Tanker Owners Pollution Federation' },
  { Acronym: 'LNG', FullForm: 'Liquefied natural gas carrier' },
  { Acronym: 'LPG', FullForm: 'Liquefied petroleum gas carrier' },
  { Acronym: 'LR', FullForm: 'Lloyd\'s Register' },
  { Acronym: 'MARAD', FullForm: 'United States Maritime Administration' },
  { Acronym: 'MARPOL', FullForm: 'International Convention for the Prevention of Pollution from Ships' },
  { Acronym: 'MAVIS', FullForm: 'Marine audio-visual instruction system' },
  { Acronym: 'NKK', FullForm: 'Nippon Kaiji Kyokai' },
  { Acronym: 'NUMAST', FullForm: 'National Union of Marine, Aviation & Shipping Transport Officers' },
  { Acronym: 'NVOCC', FullForm: 'Non vessel operating common carrier' },
  { Acronym: 'OBO', FullForm: 'Ore/bulk/oil carrier' },
  { Acronym: 'OCIMF', FullForm: 'Oil Companies International Marine Forum' },
  { Acronym: 'OECD', FullForm: 'Organisation for Economic Co-operation and Development' },
  { Acronym: 'OPA 90', FullForm: 'United States Oil Pollution Act of 1990' },
  { Acronym: 'OPEC', FullForm: 'Organization of Petroleum Exporting Countries' },
  { Acronym: 'OPRC', FullForm: 'Oil Pollution Preparedness, Response and Co-operation' },
  { Acronym: 'P & I', FullForm: 'Protection and Indemnity' },
  { Acronym: 'PRS', FullForm: 'Polskie Rejestr Statkow' },
  { Acronym: 'RCC', FullForm: 'Rescue Co-ordination Centre' },
  { Acronym: 'RINA', FullForm: 'Registro Italiano Navale' },
  { Acronym: 'RINAVE', FullForm: 'Registro Internacional Navale SA' },
  { Acronym: 'RINET', FullForm: 'Reinsurance and Insurance Network' },
  { Acronym: 'RMT', FullForm: 'National Union of Rail, Maritime & Transport Workers' },
  { Acronym: 'RNLI', FullForm: 'Royal National Life-boat Institution' },
  { Acronym: 'SAR', FullForm: 'Search and rescue' },
  { Acronym: 'SART', FullForm: 'Survival craft radar transponders' },
  { Acronym: 'SIGTTO', FullForm: 'Society of International Gas Tanker & Terminal Operators' },
  { Acronym: 'SITPRO', FullForm: 'Simplification of Industrial Trade Procedures Board' },
  { Acronym: 'SNAME', FullForm: 'Society of Naval Architects and Marine Engineers' },
  { Acronym: 'SOLAS', FullForm: 'Safety of life at sea' },
  { Acronym: 'STCW', FullForm: 'Standards of Training, Certification & Watchkeeping' },
  { Acronym: 'TEU', FullForm: 'Twenty foot equivalent unit' },
  { Acronym: 'TOVALOP', FullForm: 'Tanker Owners Voluntary Agreement concerning Liability for Oil Pollution' },
  { Acronym: 'U/C', FullForm: 'Under construction' },
  { Acronym: 'ULCC', FullForm: 'Ultra large crude carrier' },
  { Acronym: 'UNCLOS', FullForm: 'United Nations Conference on the Law of the Sea' },
  { Acronym: 'UNCTAD', FullForm: 'United Nations Conference on Trade and Development' },
  { Acronym: 'USNH', FullForm: 'United States North of Hatteras' },
  { Acronym: 'VDMA', FullForm: 'German Machinery Manufacturers & Plantmakers Association' },
  { Acronym: 'VLCC', FullForm: 'Very large crude carrier' },
  { Acronym: 'WMO', FullForm: 'World Meteorological Organisation' },
  { Acronym: 'WNA', FullForm: 'Winter North Atlantic Maritime' },
];
export const morseCodeLettersAM = [
  { Char: 'A', Code: '· -' },
  { Char: 'B', Code: '- · · ·' },
  { Char: 'C', Code: '- · - ·' },
  { Char: 'D', Code: '- · ·' },
  { Char: 'E', Code: '·' },
  { Char: 'F', Code: '· · - ·' },
  { Char: 'G', Code: '- - ·' },
  { Char: 'H', Code: '· · · ·' },
  { Char: 'I', Code: '· ·' },
  { Char: 'J', Code: '· - - -' },
  { Char: 'K', Code: '- · -' },
  { Char: 'L', Code: '· - · ·' },
  { Char: 'M', Code: '- -' }
];

export const morseCodeLettersNZ = [
  { Char: 'N', Code: '- ·' },
  { Char: 'O', Code: '- - -' },
  { Char: 'P', Code: '· - - ·' },
  { Char: 'Q', Code: '- - · -' },
  { Char: 'R', Code: '· - ·' },
  { Char: 'S', Code: '· · ·' },
  { Char: 'T', Code: '-' },
  { Char: 'U', Code: '· · -' },
  { Char: 'V', Code: '· · · -' },
  { Char: 'W', Code: '· -' },
  { Char: 'X', Code: '- · · -' },
  { Char: 'Y', Code: '- · -' },
  { Char: 'Z', Code: '- - · ·' }
];

export const morseCodeNumbers = [
  { Num: '1', Code: '· - - - -' },
  { Num: '2', Code: '· · - - -' },
  { Num: '3', Code: '· · · - -' },
  { Num: '4', Code: '· · · · -' },
  { Num: '5', Code: '· · · · ·' },
  { Num: '6', Code: '- · · · ·' },
  { Num: '7', Code: '- - · · ·' },
  { Num: '8', Code: '- - - · ·' },
  { Num: '9', Code: '- - - - ·' },
  { Num: '0', Code: '- - - - -' }
];
